import { MDBCollapse, MDBContainer, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBNavbar, MDBNavbarBrand, MDBNavbarItem, MDBNavbarLink, MDBNavbarNav, MDBNavbarToggler, MDBRow } from 'mdb-react-ui-kit';
import { useState } from 'react'
import { NavLink, Link, useNavigate } from 'react-router'
import  logo from '../assets/logo.jpeg'

export function NavBar() {

    const [openBasic, setOpenBasic] = useState(false);

    // useNavigate
    const navigate = useNavigate()

    return (
        <>

            <MDBContainer className={'border border-1 border-top-0 border-start-0 border-end-0'}>
                <MDBRow className={'border border-0 border-success d-flex flex-column justify-content-center align-items-center'}>
                    <p style={{ color: '#1B5E20' }} className={'border border-0 border-success fs-1 text-center fw-bold mb-0'}>NUS NETWORK GHANA</p>
                    <img onClick={() => navigate('')} style={{ height: '80px', width: '80px' }} className={'border border-0 border-danger '} src={logo} alt="logo" />
                </MDBRow>
            </MDBContainer>

            <MDBNavbar className={'border border-0 border-danger'} expand='lg' light bgColor='light'>
                <MDBContainer >
                    <MDBNavbarBrand className={'invisible'} href='#'>
                        <Link to={''}>
                            <img style={{ height: '35px' }} className='img-fluid' src={logo} alt="logo" />
                        </Link>
                    </MDBNavbarBrand>

                    <MDBNavbarToggler
                        aria-controls='navbarSupportedContent'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                        onClick={() => setOpenBasic(!openBasic)}
                    >
                        <MDBIcon icon='bars' fas />
                    </MDBNavbarToggler>

                    <MDBCollapse navbar open={openBasic}>
                        <hr className="hr hr-blurry d-lg-none" />
                        <MDBNavbarNav className='me-auto mb-2 mb-lg-0'>
                            <MDBNavbarItem>
                                <MDBNavbarLink tag={'div'} aria-current='page' href='#'>
                                    <NavLink to={''} className={({ isActive }) => isActive ? 'text-warning' : 'text-muted'}>Home</NavLink>
                                </MDBNavbarLink>
                            </MDBNavbarItem>
                            <MDBNavbarItem>
                                <MDBNavbarLink tag={'div'} href='#'>
                                    <NavLink to={'about_us'} className={({ isActive }) => isActive ? 'text-warning' : 'text-muted'}>About Us</NavLink>
                                </MDBNavbarLink>
                            </MDBNavbarItem>
                            <MDBNavbarItem>
                                <MDBNavbarLink tag={'div'} href='#'>
                                    <NavLink to={'contact_us'} className={({ isActive }) => isActive ? 'text-warning' : 'text-muted'}>Contact Us</NavLink>
                                </MDBNavbarLink>
                            </MDBNavbarItem>
                            <MDBNavbarItem>
                                <MDBDropdown>
                                    <NavLink to={'meet_our_team'} className={({ isActive }) => isActive ? 'text-primary' : 'text-muted'}>
                                        <MDBDropdownToggle tag='a' className='nav-link border border-0 border-danger' role='button'>
                                            <NavLink to={'meet_our_team'} className={({ isActive }) => isActive ? 'text-warning' : 'text-muted'}>Meet Our Team</NavLink>
                                        </MDBDropdownToggle>
                                    </NavLink>
                                    <MDBDropdownMenu>
                                        <MDBDropdownItem link onClick={() => navigate('meet_our_team/our_staff')}>
                                            Our Staff
                                        </MDBDropdownItem>
                                        <MDBDropdownItem link onClick={() => navigate('meet_our_team/our_board_of_advisor')}>
                                            Our Board Of Advisors
                                        </MDBDropdownItem>
                                    </MDBDropdownMenu>
                                </MDBDropdown>
                            </MDBNavbarItem>
                            <MDBNavbarItem>
                                <MDBDropdown> 
                                    <NavLink to={'media/news'} className={({ isActive }) => isActive ? 'text-primary' : 'text-muted'}>
                                        <MDBDropdownToggle tag={'a'} className='nav-link border border-0 border-danger' role='button'>
                                            <NavLink to={'media/news'} className={({ isActive }) => isActive ? 'text-warning' : 'text-muted'}>Media</NavLink>
                                        </MDBDropdownToggle>
                                    </NavLink>
                                    <MDBDropdownMenu>
                                        <MDBDropdownItem link onClick={() => navigate('media/news')}>
                                            News
                                        </MDBDropdownItem>
                                        <MDBDropdownItem link onClick={() => navigate('media/gallery')}>
                                            Gallery
                                        </MDBDropdownItem>
                                    </MDBDropdownMenu>
                                </MDBDropdown>
                            </MDBNavbarItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBContainer>
            </MDBNavbar>
        </>
    )
}